import { Component, linkedSignal, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { MediaType } from 'src/app/models/enums/MediaType.enum';
import { LabMedias, Video } from 'src/app/models/types/Product/Product.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { ProductsService } from 'src/app/services/api/products.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ModalComponent } from '../../modal/modal.component';
import { MediaSelectorComponent } from '../../product-page/media-selector/media-selector.component';
import { VideoComponent } from '../../product-page/video/video.component';

@Component({
  selector: 'app-jewel-detail-modal',
  imports: [
    ModalComponent,
    MediaSelectorComponent,
    VideoComponent,
    SharedModule
  ],
  templateUrl: './jewel-detail-modal.component.html',
  styleUrl: './jewel-detail-modal.component.scss'
})
export class JewelDetailModalComponent {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  public readonly SAFFRON_STAR = "./../../../../assets/icons/star-saffron.svg";

  private _medias: WritableSignal<LabMedias> = signal([]);
  public medias: Signal<LabMedias> = this._medias.asReadonly();

  private _images: WritableSignal<string[]> = signal([]);
  public images: Signal<string[]> = this._images.asReadonly();

  public isOpenedModal: WritableSignal<boolean> = signal(false);

  private _selectedMediaIndex: WritableSignal<number> = signal(0);

  public selectedMediaType: WritableSignal<MediaType | null> = signal(null);

  public covers: WritableSignal<string[]> = linkedSignal(() => {
    let covers: string[] = [];
    if (this.selectedMediaType() === MediaType.Video) {
      covers = this.medias().map(media => media.coverUrl || media.cover);
    } else if (this.selectedMediaType() === MediaType.Image) {
      covers = this.images();
    }
    return covers;
  });

  public selectedCover: WritableSignal<string> = linkedSignal(() => this.covers()[this._selectedMediaIndex()] || this.SAFFRON_STAR);
  public selectedVideo: WritableSignal<Video> = linkedSignal(() => this.medias()[this._selectedMediaIndex()] as Video);

  public get MediaType(): typeof MediaType {
    return MediaType;
  }

  constructor(
    public readonly productsService: ProductsService,
    public readonly loaderService: LoaderService
  ) { }

  openModal(medias: LabMedias, images: string[]) {
    if (medias.length === 0) {
      this.selectedMediaType.set(MediaType.Image);
    }
    if (images.length === 0) {
      this.selectedMediaType.set(MediaType.Video);
    }
    if (medias.length === 0 && images.length === 0) {
      this.selectedMediaType.set(null);
    } else {
      this.selectedMediaType.set(medias.length > 0 ? MediaType.Video : MediaType.Image);
    }
    this._medias.set(medias);
    this._images.set(images);
    this.isOpenedModal.set(true);
    this.modal.buildModal(() => this.handleClose(), 'lg', 'jewel-detail');
  }

  handleConfirm() {
    this.handleClose();
  }

  private handleClose() {
    this.modal.dismiss();
    this.isOpenedModal.set(false);
  }

  handleChangeMedia(index: number) {
    this._selectedMediaIndex.set(index);
  }
}
